module.exports = __webpack_public_path__ + "img/close.3cb56f87.svg";